const token = () => document.querySelector('meta[name="csrf-token"]').content;

const defaultOptions = {
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-Token': token(),
  },
  credentials: 'include',
};

const wrapper = async (
  method,
  {
    image, attachments, payload = {}, name, url, catch: catchCallback,
  },
) => {
  try {
    const options = {
      ...defaultOptions,
      method,
    };

    if (method !== 'GET') {
      if (image) {
        const formData = new FormData();
        formData.append('image', image, name);

        options.body = formData;
        delete options.headers['Content-Type'];
      } else if (attachments && attachments.length > 0) {
        const formData = new FormData();
        const keys = Object.keys(payload);

        for (let i = 0; i < attachments.length; i += 1) {
          formData.append('browse_file[]', attachments[i]);
        }

        for (let i = 0; i < keys.length; i += 1) {
          formData.append(`${keys[i]}`, payload[keys[i]]);
        }

        options.body = formData;
        delete options.headers['Content-Type'];
      } else {
        options.body = JSON.stringify(payload);
      }
    }
    const request = await fetch(url, options);
    const response = await request.json();

    return response;
  } catch (error) {
    if (catchCallback) {
      catchCallback(error);
    }
    console.warn(error) // eslint-disable-line
    return { serverErrors: error };
  }
};

const Fetch = {
  get: wrapper.bind(null, 'GET'),
  post: wrapper.bind(null, 'POST'),
};

export default Fetch;
